function PanelLotery(t) {
  this.duration = t.duration || 5e3
  this.length = t.length
  this.el = document.querySelector(t.el)
  this.round = 0
  this.playing = !1
  this.panelFaceBg = t.bg
  this.el.innerHTML = `
<div class="panel-face">

</div>
<div class="panel-btn"></div>
`
  this.btn = this.el.querySelector(".panel-btn")
  this.face = this.el.querySelector(".panel-face")
  this.face.style.cssText += `

    -webkit-transition: -webkit-transform ${this.duration}ms;
    transition: -webkit-transform ${this.duration}ms;
    transition: transform ${this.duration}ms;
    transition: transform ${this.duration}ms, -webkit-transform ${this.duration}ms;
    background-image:url(${this.panelFaceBg});
  `
  this.btn.style.cssText = `
    -webkit-transition:-webkit-transform 0.5s;
    transition: -webkit-transform 0.5s;
    transition: transform 0.5s;
    transition: transform 0.5s, -webkit-transform 0.5s
  `
}

PanelLotery.prototype.playto = function(t, i) {
  var n = this
  if ("number" != typeof t) return void console.log("prize n should be a number")
  if (t < 0 || t >= this.length) return void console.log("prize n should be 0-" + this.length)
  if (!this.playing) {
    this.playing = !0
    this.el.classList.add("playing")
    this.round++
    let s = 360 / this.length / 2 + 360 * (1 - (t + 1) / this.length + 3 * this.round)
    this.face.style.cssText += `
      -webkit-transform : rotate ${s}deg);
      transform: rotate( ${s}deg)
    `
    setTimeout(function() {
      ;(n.playing = !1), n.el.classList.remove("playing"), "function" == typeof i && i()
    }, n.duration + 600)
  }
}

export default PanelLotery
